// extracted by mini-css-extract-plugin
export default {"paginationWrap":"paginate_paginationWrap__+AJ9e"};